import { ReactNode } from "react";

import { Navigate } from "react-router-dom";

import { useToken } from "../../../hooks/useToken";

export type TGuestGuardProps = {
	children: ReactNode;
};

export function GuestGuard({ children }: TGuestGuardProps) {
	const { token } = useToken();

	if (token) {
		return <Navigate to="/" />;
	}

	return <>{children}</>;
}
